import React, { useState } from "react";
import MobilePageLayout from "../components/MobilePageLayout";
import StepProgress from "../components/StepProgress";
import HomeButton from "../components/HomeButton";

const LoginPage = ({ onNext }) => {
  const [code, setCode] = useState("91");
  const [phone, setPhone] = useState("");

  const handleNext = () => {
    if (phone.length < 10) return alert("Invalid phone number");
    onNext(`${code}${phone}`);
  };

  return (
    <MobilePageLayout ctaLabel="Next" onCtaClick={handleNext}>
      <img src="/logo.png" className="logo" alt="LOKRAM" />

      <StepProgress current={2} />
      <HomeButton />

      <h2 className="page-title">Login</h2>

      <div className="input-row">
        <input
          className="input-code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <input
          className="input-phone"
          placeholder="Phone number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>
    </MobilePageLayout>
  );
};

export default LoginPage;
